import { jsx as e } from "react/jsx-runtime";

import t from "@ui-components-3/ui/lib/utils/classNames";

import { useCallback as r } from "react";

import { useFormContext as o } from "react-hook-form";

import { WEEK_DAYS_OPTIONS as s } from "../../../schemas.js";

import { useProviderSchedule as i } from "../../../hooks/useProviderSchedule.js";

const a = ({name: a}) => {
    const {watch: l, setValue: n} = o(), {variantClassNames: d, isSubmittingSchedule: u} = i(), m = l(a), c = r((e => {
        n(a, e, {
            shouldDirty: !0,
            shouldTouch: !0,
            shouldValidate: !0
        });
    }), [ a, n ]), b = r((e => () => {
        c(m.includes(e) ? [ ...m ].filter((t => t !== e)) : [ ...m, e ]);
    }), [ m, c ]);
    return e("div", {
        className: "flex items-center justify-between gap-1",
        children: s.map((r => {
            const o = m?.includes(r);
            return e("button", {
                type: "button",
                className: t("typography-body-l inline-flex h-10 max-w-[40px] flex-1 items-center justify-center rounded-xl border text-center font-medium disabled:pointer-events-none disabled:text-neutral-500", o ? t(d.weekDayButtonActive, "disabled:border-neutral-400 disabled:bg-[#E4E6EB]") : "border-neutral-400 bg-neutral-200 text-neutral-600 hover:bg-neutral-100 disabled:border-neutral-300"),
                onClick: b(r),
                disabled: !!u,
                children: r[0]
            }, r);
        }))
    });
};

export { a as default };
//# sourceMappingURL=WeekDaysField.js.map
